export type MasteryReviewFilterType =
	| "correct"
	| "incorrect"
	| "skipped"
	| "almostcorrect"
	| "marked";

/** Maps a mastery band key from config (`level` or `id`) to review-checkbox filter types (case-insensitive). */
const masteryBandKeyToReviewFilterType = (
	key: string,
): MasteryReviewFilterType | undefined => {
	const k = key.trim().toLowerCase();
	switch (k) {
		case "high":
			return "correct";
		case "medium":
			return "almostcorrect";
		case "low":
			return "incorrect";
		case "skipped":
			return "skipped";
		case "marked":
			return "marked";
		default:
			return undefined;
	}
};

export const resolveMasteryRowReviewFilterType = (item: {
	level: string;
	id: string;
}): MasteryReviewFilterType | undefined =>
	masteryBandKeyToReviewFilterType(item.level) ??
	masteryBandKeyToReviewFilterType(item.id);
